var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcContentNotAvailable = function SvgIcContentNotAvailable(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.9165 136.603C124.332 136.603 153.043 107.696 153.043 71.9122C153.043 36.1284 124.205 7.22119 88.9165 7.22119C53.5015 7.22119 24.79 36.1284 24.79 71.9122C24.79 107.696 53.5015 136.603 88.9165 136.603Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.869 29.5062C151.733 29.5062 154.055 27.1686 154.055 24.2851C154.055 21.4015 151.733 19.064 148.869 19.064C146.005 19.064 143.684 21.4015 143.684 24.2851C143.684 27.1686 146.005 29.5062 148.869 29.5062Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.458 9.1313C158.414 9.1313 160 7.5349 160 5.56565C160 3.59639 158.414 2 156.458 2C154.503 2 152.917 3.59639 152.917 5.56565C152.917 7.5349 154.503 9.1313 156.458 9.1313Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2056 29.3793C30.1615 29.3793 31.7471 27.7829 31.7471 25.8137C31.7471 23.8444 30.1615 22.248 28.2056 22.248C26.2496 22.248 24.6641 23.8444 24.6641 25.8137C24.6641 27.7829 26.2496 29.3793 28.2056 29.3793Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57707 98.1452C10.2095 98.1452 13.1541 95.1805 13.1541 91.5233C13.1541 87.8661 10.2095 84.9014 6.57707 84.9014C2.94466 84.9014 0 87.8661 0 91.5233C0 95.1805 2.94466 98.1452 6.57707 98.1452Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_70782_325500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.553 39.5668L133.565 121.577C133.565 124.378 131.288 126.543 128.506 126.543H49.0749C46.2923 126.543 44.0156 124.251 44.0156 121.577V16.1354C44.0156 13.3338 46.2923 11.1689 49.0749 11.1689H106.624L132.553 39.5668Z",
    fill: "url(#paint0_linear_70782_325500)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7191 110.116H67.1618C66.5294 110.116 66.0234 109.479 66.0234 108.715C66.0234 107.951 66.5294 107.314 67.1618 107.314H82.7191C83.3515 107.314 83.8574 107.951 83.8574 108.715C83.8574 109.606 83.3515 110.116 82.7191 110.116Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8653 110.116H56.9167C56.2843 110.116 55.7783 109.479 55.7783 108.715C55.7783 107.951 56.2843 107.314 56.9167 107.314H73.8653C74.4977 107.314 75.0036 107.951 75.0036 108.715C75.0036 109.606 74.4977 110.116 73.8653 110.116Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4937 28.3603H57.4226C56.5372 28.3603 55.7783 27.5962 55.7783 26.7048C55.7783 25.8134 56.5372 25.0493 57.4226 25.0493H95.4937C96.3791 25.0493 97.138 25.8134 97.138 26.7048C97.138 27.5962 96.3791 28.3603 95.4937 28.3603Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0945 37.5292H57.4226C56.5372 37.5292 55.7783 36.7652 55.7783 35.8737C55.7783 34.9823 56.5372 34.2183 57.4226 34.2183H71.968C72.8534 34.2183 73.6123 34.9823 73.6123 35.8737C73.6123 36.7652 72.8534 37.5292 72.0945 37.5292Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.624 11.1689V33.8363C106.624 37.0199 109.407 39.5668 112.569 39.5668H132.553",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 88.0786H77.3633H72.5266H57.8984C57.3086 88.0786 56.7188 88.6737 56.7188 89.5069C56.7188 90.2211 57.1906 90.9352 57.8984 90.9352H72.5266H77.3633H121.248C121.838 90.9352 122.427 90.3401 122.427 89.5069C122.309 88.6737 121.838 88.0786 121.248 88.0786Z",
    fill: "#D5DDEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.13 77.7231H104.85H99.3055H57.8984C57.3086 77.7231 56.7188 78.3183 56.7188 79.1515C56.7188 79.8656 57.1906 80.5798 57.8984 80.5798H99.3055H104.85H121.13C121.72 80.5798 122.309 79.9846 122.309 79.1515C122.192 78.3183 121.72 77.7231 121.13 77.7231Z",
    fill: "#D5DDEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.484 67.249H117.237H112.99H57.8984C57.3086 67.249 56.7188 67.8441 56.7188 68.6773C56.7188 69.3915 57.1906 70.1056 57.8984 70.1056H112.99H117.709H121.366C121.956 70.1056 122.545 69.5105 122.545 68.6773C122.663 67.9632 122.074 67.249 121.484 67.249Z",
    fill: "#D5DDEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2399 111.17H57.8984C57.3086 111.17 56.7188 110.574 56.7188 109.741C56.7188 109.027 57.1906 108.313 57.8984 108.313H75.2399C75.8297 108.313 76.4196 108.908 76.4196 109.741C76.4196 110.694 75.8297 111.17 75.2399 111.17Z",
    fill: "#E3EAF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.956 56.894H108.153H104.732H57.8984C57.3086 56.894 56.7188 57.4892 56.7188 58.3223C56.7188 59.0365 57.1906 59.7507 57.8984 59.7507H104.732H108.153H121.838C122.663 59.7507 123.135 59.1555 123.135 58.3223C123.135 57.6082 122.663 56.894 121.956 56.894Z",
    fill: "#D5DDEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8423 117.478H31.0016C27.9344 117.478 25.457 114.978 25.457 111.883V72.9621C25.457 62.1308 34.1867 53.4419 44.8039 53.4419C55.4212 53.4419 64.1509 62.2498 64.1509 72.9621V112.002C64.2688 114.978 61.7915 117.478 58.8423 117.478ZM36.5461 106.408H53.2977V72.9621C53.2977 68.3201 49.5227 64.5113 44.9219 64.5113C40.3211 64.5113 36.5461 68.3201 36.5461 72.9621V106.408V106.408Z",
    fill: "#989FB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2853 128.071H19.9125C16.4914 128.071 13.6602 125.214 13.6602 121.763V88.0784C13.6602 84.6266 16.4914 81.77 19.9125 81.77H70.2853C73.7064 81.77 76.5376 84.6266 76.5376 88.0784V121.763C76.5376 125.214 73.7064 128.071 70.2853 128.071Z",
    fill: "#C2C8D6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4106 99.7428C51.4106 102.242 49.9949 104.385 47.9895 105.456V112.36C47.9895 114.026 46.6918 115.335 45.0402 115.335C43.3887 115.335 42.091 114.026 42.091 112.36V105.456C40.0855 104.385 38.6699 102.242 38.6699 99.7428C38.6699 96.172 41.5012 93.3154 45.0402 93.3154C48.5793 93.3154 51.4106 96.172 51.4106 99.7428Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_70782_325500",
    x: 22.0156,
    y: 0.168945,
    width: 133.55,
    height: 159.374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_70782_325500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_70782_325500",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70782_325500",
    x1: 88.7611,
    y1: 8.50023,
    x2: 88.7611,
    y2: 127.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcContentNotAvailable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-content-not-available.2879e929.svg";
export { ForwardRef as ReactComponent };